class MFRStoreLocator {
    constructor( i, e ) {
        this.$index = i;
        this.$element = $( e );

        this.selectors = {
            form: "[data-form]"
        }

        this.init();
    }

    init() {
        this.$form = this.$element.find( this.selectors.form );

        this.$form.on( "submit", this.__handleFormSubmit.bind( this ) );
    }

    __handleFormSubmit( e ) {
        e.preventDefault();
        const form = $( e.currentTarget );
        const action = form.attr( "action" );
        const formData = form.serialize();
        const dataURL = `${ action }?${ formData }`
        window.location = dataURL;
    }
}